import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // api: "https://192.168.1.199:8088/boardgame/boardgameeveryday/web/api.php",
    // api: "https://admin.blayblay.com/boardgame/boardgameeveryday/web/api.php",

    // api: "api/api.php",
    // api: "https://localhost/boardgame/boardgameeveryday/web/api.php",
    api: "/boardgame/boardgameeveryday/web/api.php",
    // api: "https://boardgameeveryday.herokuapp.com/api/",
    server: true,
    // server: false,
    agree: false,
    language: "TH"
  },
  getters: {
    getLG: state => () => state.language
  },
  mutations: {

  },
  actions: {

  }
})